import './wrestlers.css';
import { STATUS } from '@type/db-types';
import useEventContext from '@hooks/useEventContext';
import RegisteredAthletesTable from '@pages/Events/RegisteredAthletesTable';
import { EventWithMembership } from '@modules/supabase/events';

export default function FailedPayments() {
    const { event, isEventAdmin } = useEventContext();

    return event ? (
        <RegisteredAthletesTable
            event={event as EventWithMembership}
            adminView={isEventAdmin}
            statuses={[
                STATUS.CANCELLED,
                STATUS.DECLINED,
                STATUS.LEFT,
                STATUS.PENDING,
                STATUS.REMOVED,
            ]}
        />
    ) : null;
}
